<template>
  <v-container>
    <v-row justify="center">
      <v-col xs="12" sm="6">
        <v-file-input
          label="Select a file"
          accept=".csv, .xlsx"
          v-model="currentFile"
          variant="underlined"
        />
        <v-alert
          v-if="errorMessages.length > 0"
          variant="outlined"
          type="error"
          title="Error"
        >
          <div v-for="errorMessage in errorMessages">
            {{ errorMessage }}
          </div>
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="align-self-center text-center">
        <p-primary-button
          :disabled="loading || !currentFile[0]"
          :loading="loading"
          @click="uploadFile"
        >
          Upload
        </p-primary-button>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { ref, type Ref } from "vue";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import { uploadSuppliers } from "@/services/suppliersService";

const currentFile = ref([]);
const loading = ref(false);
const activeError = ref(false);
const errorMessages: Ref<string[]> = ref([]);

const emit = defineEmits<{
  (e: "suppliers-uploaded"): void;
}>();

const uploadFile = async () => {
  let formData = new FormData();
  formData.append("file", currentFile.value[0]);
  try {
    loading.value = true;

    await uploadSuppliers(formData);

    emit("suppliers-uploaded");
  } catch (e) {
    activeError.value = true;
    //@ts-ignore
    errorMessages.value = Object.values(e.response.data).flat();
  } finally {
    loading.value = false;
  }
};
</script>
